import { includes, reduce, some, uniq } from 'lodash-es';
import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';
import { incumbentAndCrosses } from '../stateLocators';

export class SearchTextFilter extends FilterBase {
  matchCount: number = 0;

  constructor(private gridRows, private state) {
    super();
  }

  makeIndex(): any {
    // We should be able to add a manual filter with a name for text matches. At some point
    // we might choose to make this a custom filter or see if we can find an existing filter
    // which is a better match (for example, see the above ContinuousRangeFilter which shows
    // up in the code and unit tests but not in the documentation).
    return new PourOver.makeManualFilter('textMatch');
  }

  getMatchSet(collection: any, filterSettings): any {
    if (filterSettings.searchText) {
      let matchingRows = new Set<number>();
      let regex = new RegExp(filterSettings.searchText, 'gi');

      this.matchCount = 0;

      // Go through every incumbent product (and every cross for it) looking for text matches.
      this.state.products.forEach((product) => {
        for (let value of incumbentAndCrosses(product)) {
          let matches = value.product.searchText.match(regex);

          if (matches?.length) {
            this.matchCount += matches.length;
            matchingRows.add(value.product.incumbentProductId);
          }
        }
      });

      // This converts from a set of incumbent products to include every row which includes crosses for the incumbent.
      let matches = this.gridRows.reduce((matches: number[], row, index) => {
        if (matchingRows.has(row.incumbentProductId)) {
          matches.push(index);
        }

        return matches;
      }, []);

      collection.filters.textMatch.addItems(matches);

      // Manual filters can give you a match set (what you use in and() and or() operations).
      return collection.filters.textMatch.current_query;
    }
  }

  getCounts(): any {
    return {
      matches: this.matchCount
    };
  }
}
